<template>
  <div>
    <component :is="authComponent" />
  </div>
</template>

<script>
import { usePlatformStore } from '~/store-pinia/platform'

export default defineComponent({
  name: 'Auth',
  components: {
    BookingEngineAuth: defineAsyncComponent(() => import('@/components/dialog/AuthTenants/BookingEngine/index.vue')),
    FunNowAuth: defineAsyncComponent(() => import('@/components/dialog/AuthTenants/FunNow/index.vue')),
    FunBookV2LoginModal: defineAsyncComponent(() => import('@/components/dialog/FunBookV2LoginModal.vue')),
  },
  setup() {
    const { $store: store } = useNuxtApp()
    const platformStore = usePlatformStore()
    const isBookingEngine = computed(() => store.state.isBookingEngine)
    const authComponent = computed(() =>
      platformStore.isFunBookV2 ? 'FunBookV2LoginModal' : isBookingEngine.value ? 'BookingEngineAuth' : 'FunNowAuth'
    )
    return {
      isBookingEngine,
      authComponent,
    }
  },
})
</script>
